import { CartItem } from "@omni/types/api/cart/bff/shared/cartItem.model";
import { TrackingProductModel } from "@omni/types/components/tracking/models/trackingProduct.model";
import { AddToCartTrackingInfo } from "@omni/types/components/tracking/tracking-info/feature/addToCart.trackingInfo";
import { RemoveFromCartTrackingInfo } from "@omni/types/components/tracking/tracking-info/feature/removeFromCart.trackingInfo";
import { ModelMapper } from "@omni/types/utils/modelMapper";

export const toTrackingProduct: ModelMapper<CartItem, TrackingProductModel> = (
    cartItem
) => {
    return {
        id: cartItem.sku,
        ean: cartItem.product?.ean,
        name:
            cartItem.product?.analytics?.productTitle ||
            cartItem.product?.productTitle ||
            "",
        category: cartItem.product?.analytics?.superCategoryCode,
        price: cartItem.articleSalesPrice,
        unitPrice: cartItem.articleSalesPrice,
        tax: "21%",
        currencyCode: "EUR",
        brand: cartItem.product?.brandName ?? ""
    };
};

export const toAddToCartTrackingInfo: ModelMapper<
    { item: CartItem; quantity: number },
    AddToCartTrackingInfo
> = ({ item, quantity }) => {
    const { productTitle = "", superCategoryCode = "" } =
        item.product?.analytics || {};

    const reduction =
        (item.articleStrikethroughPrice
            ? item.articleStrikethroughPrice
            : item.articleSalesPrice) - item.articleSalesPrice;

    return {
        name: productTitle || "",
        id: item.sku,
        ean: item.product?.ean,
        category: superCategoryCode,
        price: item.articleSalesPrice,
        unitPrice: item.articleSalesPrice,
        tax: "21%",
        reduction: reduction,
        currencyCode: "EUR",
        quantity: quantity,
        url: item.product?.url,
        brand: item.product?.brandName || ""
    };
};

export const toRemoveFromCartTrackingInfo: ModelMapper<
    { item: CartItem; quantity: number },
    RemoveFromCartTrackingInfo
> = ({ item, quantity }) => {
    const { productTitle = "", superCategoryCode = "" } =
        item.product?.analytics || {};
    const reduction =
        (item.articleStrikethroughPrice
            ? item.articleStrikethroughPrice
            : item.articleSalesPrice) - item.articleSalesPrice;

    return {
        name: productTitle || "",
        id: item.sku,
        ean: item.product?.ean,
        category: superCategoryCode,
        price: item.articleSalesPrice,
        unitPrice: item.articleSalesPrice,
        tax: "21%",
        reduction: reduction,
        currencyCode: "EUR",
        quantity: quantity,
        url: item.product?.url,
        brand: item.product?.brandName || ""
    };
};
